export default "__VITE_ASSET__CaBhnOHz__"